import { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { isEqual as isEqualTime } from 'date-fns';
import { usePrevious } from 'hooks';
import type { TourItemContent } from '../types';

const useShouldFetchRoute = (tourItems: TourItemContent[]) => {
  const [tourItemsKey, setTourItemsKey] = useState(Math.random());

  const coords = tourItems.map(item => item.coordinates);
  const initialTime = tourItems[0]?.time;
  const prevCoords = usePrevious<[number, number][]>(coords);
  const prevInitialTime = usePrevious<Date | undefined>(initialTime);

  useEffect(() => {
    if (
      !prevCoords ||
      !isEqual(prevCoords, coords) ||
      ((initialTime || prevInitialTime) &&
        (!initialTime ||
          !prevInitialTime ||
          !isEqualTime(initialTime, prevInitialTime)))
    ) {
      setTourItemsKey(Math.random());
    }
  }, [coords, initialTime, prevCoords, prevInitialTime]);

  return tourItemsKey;
};

export default useShouldFetchRoute;
